import * as selectors from './versions.selectors';
import reducer from './versions.reducers';

export default reducer;
export { selectors, reducer };
export { VersionAction } from './versions.actions';
export { VersionEffects } from './versions.effects';
export { VersionState, Version } from './versions.models';
export { VersionService } from './versions.service';
